import Link, { LinkProps } from "../../../components/link/Link"

const AuthFormFooterBoxLink = (props: LinkProps): JSX.Element => (
  <Link textDecor="underline" whiteSpace="normal" display="inline" {...props} />
)

export default AuthFormFooterBoxLink
